
export default {
  name: 'icon-tablo',
};
